import { useMemo } from 'react';
import { ConstraintFragment } from '@occc/graphql';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useConfig } from '@occc/config';
import { ConstraintsSection } from '../constraints-section/constraints-section.component';
import { ConstraintBlocksVisibility } from '../constraints-section/constraints-section.constants';

type TargetingSectionProps = {
  offerType: OfferType | null;
  constraints: ConstraintFragment[];
  visibleBlocks?: ConstraintBlocksVisibility;
};

export const TargetingSection = ({
  offerType,
  constraints,
  visibleBlocks,
}: TargetingSectionProps) => {
  const { config } = useConfig();

  const actualVisibleBlocks = useMemo(() => {
    if (
      visibleBlocks?.SubBrandConstraint &&
      (!config.subBrands?.enabled || offerType === OfferType.Promocodes)
    ) {
      return { ...visibleBlocks, SubBrandConstraint: false };
    }
    return visibleBlocks;
  }, [config.subBrands?.enabled, offerType, visibleBlocks]);

  return (
    <ConstraintsSection
      title='Targeting'
      constraints={constraints}
      visibleBlocks={actualVisibleBlocks}
    />
  );
};
